import { makeActionCreator } from "@ec-oem/ec.oem.oa3.ui.core/utility";

export const GET_ALL_ANNOUNCEMENT = "COMMON/ANNOUNCEMENT/GET_ALL_ANNOUNCEMENT";
export const getAllAnnouncement = makeActionCreator(GET_ALL_ANNOUNCEMENT, true);

export const SET_ALL_ANNOUNCEMENT = "COMMON/ANNOUNCEMENT/SET_ALL_ANNOUNCEMENT";
export const setAllAnnouncement = makeActionCreator(SET_ALL_ANNOUNCEMENT, true, "allAnnouncementResult");
